import { useCallback, useState } from 'react';
import { executionRunsTableDefinition } from '@/features/executionRuns/pages/executionRunsTableDefinition';
import { resultsFilesTableDefinition } from '@/features/executionRuns/pages/resultsFilesTableDefinition';
import { uploadsTableDefinition } from '@/features/executionRuns/pages/uploadsTableDefinition';
import { areColumnVisibilityModelsEqual } from '@/features/shared/components/tableSystem/columnVisibilityModel';
import type { GridColumnVisibilityModel } from '@/ui/primitives';

type ExecutionRunsColumnVisibilityModels = {
  executionRunsColumnVisibilityModel: GridColumnVisibilityModel;
  handleExecutionRunsColumnVisibilityModelChange: (nextModel: GridColumnVisibilityModel) => void;
  handleResultsFilesColumnVisibilityModelChange: (nextModel: GridColumnVisibilityModel) => void;
  handleUploadsColumnVisibilityModelChange: (nextModel: GridColumnVisibilityModel) => void;
  resultsFilesColumnVisibilityModel: GridColumnVisibilityModel;
  uploadsColumnVisibilityModel: GridColumnVisibilityModel;
};

export const useExecutionRunsColumnVisibilityModels = (): ExecutionRunsColumnVisibilityModels => {
  const [executionRunsColumnVisibilityModel, setExecutionRunsColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>(executionRunsTableDefinition.defaultColumnVisibilityModel);
  const [resultsFilesColumnVisibilityModel, setResultsFilesColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>(resultsFilesTableDefinition.defaultColumnVisibilityModel);
  const [uploadsColumnVisibilityModel, setUploadsColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>(uploadsTableDefinition.defaultColumnVisibilityModel);

  const handleExecutionRunsColumnVisibilityModelChange = useCallback(
    (nextModel: GridColumnVisibilityModel): void => {
      setExecutionRunsColumnVisibilityModel((currentModel) =>
        areColumnVisibilityModelsEqual(currentModel, nextModel) ? currentModel : nextModel,
      );
    },
    [],
  );
  const handleResultsFilesColumnVisibilityModelChange = useCallback(
    (nextModel: GridColumnVisibilityModel): void => {
      setResultsFilesColumnVisibilityModel((currentModel) =>
        areColumnVisibilityModelsEqual(currentModel, nextModel) ? currentModel : nextModel,
      );
    },
    [],
  );
  const handleUploadsColumnVisibilityModelChange = useCallback(
    (nextModel: GridColumnVisibilityModel): void => {
      setUploadsColumnVisibilityModel((currentModel) =>
        areColumnVisibilityModelsEqual(currentModel, nextModel) ? currentModel : nextModel,
      );
    },
    [],
  );

  return {
    executionRunsColumnVisibilityModel,
    handleExecutionRunsColumnVisibilityModelChange,
    handleResultsFilesColumnVisibilityModelChange,
    handleUploadsColumnVisibilityModelChange,
    resultsFilesColumnVisibilityModel,
    uploadsColumnVisibilityModel,
  };
};
